import api from '@/utils/api/api'
import type { UserPreferences } from '@/shared/types/preferences'

const preferencesApi = {
    getPreferences: (endpoint: string, token: string): Promise<UserPreferences> => {
        return api.get<UserPreferences>(
            `${endpoint}/preferences`,
            undefined,
            { Authorization: `Bearer ${token}` }
        )
    },

    patchPreferences: (endpoint: string, token: string, data: Partial<UserPreferences>): Promise<UserPreferences> => {
        return api.patch<UserPreferences>(
            `${endpoint}/preferences`,
            undefined,
            JSON.stringify(data),
            {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            }
        )
    },
}

export default preferencesApi
